import React from "react";
import ConfigurationDuplicateDetectionCard from "../cards/ConfigurationDuplicateDetectionCard";
import ConfigurationNewIntegrationsCard from "../cards/ConfigurationNewIntegrationsCard";
import ConfigurationHelpGuideURLCard from "../cards/ConfigurationHelpGuideURLCard";
import CustomizationViewPublishButtons from "../helpers/CustomizationViewPublishButtons";
import { SectionHeaderWrapper } from "../../../../shared/SectionHeaderWrapper";

const ConfigurationConfigurationSettingsPage = () => {
  return (
    <SectionHeaderWrapper
      title="Configuration"
      subtitle="Customize your preferences in Merge Link"
      buttons={<CustomizationViewPublishButtons />}
    >
      <ConfigurationNewIntegrationsCard />
      <ConfigurationDuplicateDetectionCard />
      <ConfigurationHelpGuideURLCard />
    </SectionHeaderWrapper>
  );
};

export default ConfigurationConfigurationSettingsPage;
